
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/eventLogin",
      function () {
        return require("private-next-pages/event/eventLogin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/eventLogin"])
      });
    }
  